<template>
<div class="for-alert" @click="$router.push('/sound')" >
    <Alert :msg = msg></Alert>
</div>
  
</template>

<script>
import Alert from '../components/Alert'
export default {
    mounted(){
        console.log(this.$route);
        
    },
    data(){
        return{
            orderId:this.$route.params.id,
            flag:this.$route.query.q,
            file:this.$route.query.file
        }
    },
    computed:{
        msg(){
            let msg={}
            let id = localStorage.getItem('orderId')
            if(this.orderId == id && this.flag == 'true'){
                msg={
                    type:'success',
                    arr:[`Заказ ${this.file} успешно создан.`,'Наш менеджер обязательно свяжется с Вами.','Корзина будет очищена.','Спасибо за заказ' ]
                }
                this.$store.commit('cart/clear')   


            } else {
                msg = {
                    type:'error',
                    arr:['Ошибка обработки данных']
                }
            }
            return msg
        }


    },
    methods:{
        reDirect(){
            this.$router.push('/sound')
        }

    },
    components:{
        Alert
    }

}
</script>

<style>

</style>